<div class="mybets-scoreboard_players">
    <div class="cell">{{ vm.eventName }}</div>
    <div class="cell"><ms-my-bets-scoreboard-time [vm]="vm.getEventTimeViewModel()"></ms-my-bets-scoreboard-time></div>
</div>
